// extracted by mini-css-extract-plugin
export default {"wrapper":"EditSpaceModal_wrapper__fbq14","formControl":"EditSpaceModal_formControl__59n4s","action":"EditSpaceModal_action__XNQVk","details":"EditSpaceModal_details__pqFU+"};